import apiClient from '../utils/apiClient';

export const employeesApi = {
  getAll: async (params = {}) => {
    const response = await apiClient.get('/employees', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/employees/${id}`);
    return response.data;
  },

  getWithoutAssets: async () => {
    const response = await apiClient.get('/employees/without-assets');
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/employees', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.put(`/employees/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/employees/${id}`);
    return response.data;
  }
};
